import { Components, Theme } from '@mui/material';

export const MuiInputAdornment: Components<Omit<Theme, 'components'>>['MuiInputAdornment'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      paddingBottom: '4px',
    }),
  },
};
